import { usePixelLoader } from '~/hooks/usePixelLoader';

declare global {
  interface Window {
    fbq: (type: string, event: string) => void;
  }
}

interface PixelProps {
  pixelId: string;
  marketingCookies: boolean;
}

const FacebookPixel = ({ pixelId, marketingCookies }: PixelProps) => {
  usePixelLoader(() => {
    // match valid pixel id: 1+ digits
    if (pixelId?.match(/^\d+$/) && marketingCookies) {
      const script = document.createElement('script');
      script.id = 'facebook-pixel';
      script.async = true;
      script.innerHTML = `
      (function(){try{
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', "${pixelId}");
        fbq("track", "PageView");
      }catch{/*swallow exception*/}})();
      `;
      document.head.appendChild(script);

      // Return cleanup function
      return () => {
        try {
          if (script.parentNode) {
            script.parentNode.removeChild(script);
          }
        } catch {
          // Script already removed, safe to ignore
        }
      };
    }
  }, [pixelId, marketingCookies]);

  return null;
};

export default FacebookPixel;
